<template>
  <RendererHtml
    v-if="renderedMarkdown"
    :content="renderedMarkdown"
    class="tw-flex tw-flex-col tw-gap-2"
  />
</template>

<script lang="ts" setup>
import { marked } from 'marked'

const props = defineProps<{
  content: string
}>()

const renderedMarkdown = computed(() => {
  /* 
    Workaround for editor and markdown rendering lib compatibility
    When adding a newline after each <br> MarkedJS ignores it and let's the html renderer pick it up
  */
  const content = props.content.replace(/\u003cbr\u003e/g, '\u003cbr\u003e\n')

  // Parse synchronously so the markup is present during SSR (avoids a hydration
  // mismatch where the server renders nothing and the client fills it in later).
  return marked.parse(content, { async: false })
})
</script>
